import * as turf from "@turf/turf";
import { MapObject } from "./MapObject";
import { MapObjectRadiusModel } from "./MapObjectRadius.model";

export class MapObjectRadius extends MapObjectRadiusModel {
    // Add custom methods here
    toFeature(mapObject: MapObject): GeoJSON.Feature {
        const center = mapObject.coordinates;
        const options = { units: this.units };
        const diameter = turf.circle(center, this.radius, options);

        diameter.properties = {
            id: `${mapObject.uuid}_radius_${this.id}`,
            color: this.color,
            name: this.name,
            opacity: this.opacity,
            radius: this.radius,
            showBorder: this.showBorder,
            units: this.units,
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
        };
        diameter.id = `${mapObject.uuid}_radius_${this.id}`;

        return diameter as GeoJSON.Feature;
    }

    toMapboxLayer(layerId: string, mapObject: MapObject, visibility: "visible" | "none") {
        return {
            id: `${mapObject.uuid}_radius_${this.id}`,
            type: "fill",
            source: layerId,
            paint: {
                "fill-color": this.color,
                "fill-opacity": this.opacity || 0.75,
            },
            layout: {
                visibility: visibility,
            },
            filter: ["==", ["get", "id"], `${mapObject.uuid}_radius_${this.id}`],
        };
    }
    toMapboxBorderLayer(layerId: string, mapObject: MapObject, visibility: "visible" | "none") {
        return {
            id: `${mapObject.uuid}_radius_border_${this.id}`,
            type: "line",
            source: layerId,
            paint: {
                "line-color": this.color,
                "line-width": 2,
                "line-opacity": 1,
            },
            layout: {
                visibility: visibility,
            },
            filter: ["==", ["get", "id"], `${mapObject.uuid}_radius_${this.id}`],
        };
    }

    toggleVisibility(mapRef: mapboxgl.Map, mapObject: MapObject, visibility: "visible" | "none") {
        if (mapRef.getLayer(`${mapObject.uuid}_radius_${this.id}`)) {
            mapRef.setLayoutProperty(`${mapObject.uuid}_radius_${this.id}`, "visibility", visibility);
        }
        if (mapRef.getLayer(`${mapObject.uuid}_radius_border_${this.id}`)) {
            mapRef.setLayoutProperty(`${mapObject.uuid}_radius_border_${this.id}`, "visibility", visibility);
        }
        if (mapRef.getLayer(`${mapObject.uuid}_radius_label_${this.id}`)) {
            mapRef.setLayoutProperty(`${mapObject.uuid}_radius_label_${this.id}`, "visibility", visibility);
        }
    }
    removeLayerFromMapbox(mapRef: mapboxgl.Map, mapObject: MapObject) {
        if (mapRef.getLayer(`${mapObject.uuid}_radius_${this.id}`)) {
            mapRef.removeLayer(`${mapObject.uuid}_radius_${this.id}`);
        }
        if (mapRef.getLayer(`${mapObject.uuid}_radius_border_${this.id}`)) {
            mapRef.removeLayer(`${mapObject.uuid}_radius_border_${this.id}`);
        }
        if (mapRef.getLayer(`${mapObject.uuid}_radius_label_${this.id}`)) {
            mapRef.removeLayer(`${mapObject.uuid}_radius_label_${this.id}`);
        }
    }
}
